import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { api } from "../../api/api";
import { User } from "../../types";
import { Button } from "@mui/material";
import CreateModal from "./CreateServicesModal";
import dayjs from "dayjs";
import TableDateFormatter from "../../helpers/TableDateFormatter";

type Props = {};

const Services = (props: Props) => {
  const [rows, setRows] = useState<any[]>([]);
  const [modalConfig, setModalConfig] = useState<{
    data?: any;
    open: boolean;
  }>();

  const [total, setTotal] = useState();
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });
  const [sortModel, setSortModel] = useState<any>([]);
  const [search, setSearch] = useState("");

  const handleSearch = (e: any) => {
    setSearch(e.target.value);
  };

  const fetcher = async () => {
    api
      .get(
        //@ts-ignore
        `/services?limit=${paginationModel.pageSize}&page=${
          paginationModel.page
        }${
          sortModel && sortModel.length > 0
            ? `&sortOrder=${sortModel[0].sort}&sortField=${sortModel[0].field}`
            : ""
        }${search ? `&search=${search}` : ""}`
      )
      .then((res) => {
        setTotal(res.data.count);
        setRows(res.data.services);
      });
  };

  useEffect(() => {
    fetcher();
  }, [paginationModel, sortModel, search]);

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 50 },
    { field: "name", headerName: "Service", width: 150 },
    { field: "price", headerName: "Price (EUR)", width: 150 },
    {
      field: "employee_names",
      headerName: "Employees",
      width: 150,
      renderCell: ({ value }) => (value ? value.replaceAll(",", ", ") : "-"),
    },
    {
      field: "equipment_names",
      headerName: "Equipment",
      width: 150,
      renderCell: ({ value }) => (value ? value.replaceAll(",", ", ") : "-"),
    },
    {
      field: "all_time_slots",
      headerName: "Available for all time slots",
      renderCell: ({ value }) => (value === 0 ? "No" : "Yes"),
      width: 150,
    },
    // {
    //   field: "archived_at",
    //   headerName: "Archived",
    //   width: 150,
    //   renderCell: ({ row, value }) =>
    //     value ? <TableDateFormatter date={value} /> : "-",
    // },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: 100,
    //   renderCell: ({ row }) => (row.archived_at ? "Deactivated" : "Active"),
    // },

    {
      field: "actions",
      headerName: "",
      width: 200,
      renderCell: ({ row }) => {
        return (
          <>
            <Button
              variant="contained"
              color="error"
              sx={{ mr: "10px" }}
              onClick={() => {
                api.delete(`/services/${row.id}`).then((res) => {
                  fetcher();
                });
              }}
            >
              Delete
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => setModalConfig({ data: row, open: true })}
            >
              Edit
            </Button>
          </>
        );
      },
    },
  ];

  const handleClose = () => {
    setModalConfig((prev) => {
      return { data: undefined, open: false };
    });
  };

  return (
    <>
      <Button onClick={() => setModalConfig({ open: true })}>
        Create Service
      </Button>
      <div className="input_wrapper">
        <input placeholder="Search..." onKeyUp={handleSearch} />
      </div>
      <DataGrid
        rows={rows}
        columns={columns}
        onPaginationModelChange={setPaginationModel}
        rowCount={total}
        paginationModel={paginationModel}
        onSortModelChange={setSortModel}
        pageSizeOptions={[5, 10]}
        sx={{ border: 0, height: "86%" }}
        pagination
        sortingMode="server"
        paginationMode="server"
      />

      {modalConfig?.open && modalConfig && (
        <CreateModal
          modalConfig={modalConfig as any}
          handleClose={handleClose}
          fetcher={fetcher}
          setModalConfig={setModalConfig}
        />
      )}
    </>
  );
};

export default Services;
